import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const SoftPagination = forwardRef(({ Totalpages, currentPage, changePage }, ref) => {
  const pages = Array.from({ length: Totalpages }, (_, i) => i + 1);

  return (
    <SoftBox
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap={1}
      align="center"
      bgColor="white"
      p={0.8}
    >
      <SoftBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={1}
        borderRadius="sm"
        width="90px"
        border=" 1px solid #E9E9E9"
        onClick={() => currentPage !== 1 && changePage(currentPage - 1)}
        sx={{ cursor: "pointer" }}
      >
        <ChevronLeftIcon sx={{ color: "mediumgray.main" }} />

        <SoftTypography sx={{ color: "mediumgray.main" }}>Back</SoftTypography>
      </SoftBox>

      {pages?.map((page, index) => (
        <SoftBox
          key={page}
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={1}
          borderRadius="sm"
          width="33px"
          border=" 1px solid #E9E9E9"
          sx={{
            backgroundColor: page === currentPage ? "black.main" : "",
            color: page === currentPage ? "white.main" : "",
            cursor: "pointer",
          }}
          onClick={() => changePage(page)}
        >
          {page}
        </SoftBox>
      ))}

      <SoftBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={1}
        borderRadius="sm"
        width="90px"
        border=" 1px solid #E9E9E9"
        onClick={() => currentPage < Totalpages && changePage(currentPage + 1)}
        sx={{ cursor: "pointer" }}
      >
        <SoftTypography sx={{ color: "mediumgray.main" }}>Next</SoftTypography>

        <ChevronRightIcon sx={{ color: "mediumgray.main" }} />
      </SoftBox>
    </SoftBox>
  );
});

SoftPagination.propTypes = {
  Totalpages: PropTypes.number,
  currentPage: PropTypes.number,
  changePage: PropTypes.func,
};

export default SoftPagination;
